import { render, staticRenderFns } from "./SegmentTopNSetting.vue?vue&type=template&id=9c5f5c22&scoped=true"
import script from "./SegmentTopNSetting.vue?vue&type=script&lang=ts"
export * from "./SegmentTopNSetting.vue?vue&type=script&lang=ts"
import style0 from "./SegmentTopNSetting.vue?vue&type=style&index=0&id=9c5f5c22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5f5c22",
  null
  
)

export default component.exports